import keyBy from 'lodash/keyBy'

export default async function ({ gridValues, ranges, scope, docId: productRef, patch }) {
  const priceRanges = ranges.map((range) => ({
    _id: range.key,
    range: [],
  }))

  const mapIdPriceRange = keyBy(priceRanges.filter(pr => pr._id !== '0'), '_id')

  Object.keys(gridValues).forEach((s) => {
    Object.keys(gridValues[s]).forEach((c) => {
      const priceRangeId = gridValues[s][c]
      if (priceRangeId === '0') return
      mapIdPriceRange[priceRangeId].range.push({ s: +s, c: +c })
    })
  })

  try {
    Promise.all(Object.keys(mapIdPriceRange).map(id => patch({
      url: `api/model/priceRanges/${mapIdPriceRange[id]._id}`,
      data: {
        _id: id,
        range: mapIdPriceRange[id].range,
      },
    })))

    await patch({
      url: `api/model/products/${productRef}`,
      data: {
        _id: productRef,
        scope,
      },
    })

    window.alert('儲存完成')
  } catch (err) {
    window.alert('儲存失敗')
    console.log(err)
  }
}



// WEBPACK FOOTER //
// ./src/components/RangeEditor/saveData.js